export type ReportType =
  | 'program-summary'
  | 'client-demographics'
  | 'outreach-contacts'
  | 'services-provided'
  | 'mediation'
  | 'outcomes'
  | 'geographic-distribution'
  | 'case-activity'
  | 'partner-workload'
  | 'service-utilization';
export type DatePreset = 'previous_week' | 'previous_month' | 'previous_quarter' | 'custom';
export type CaseStatusFilter = 'all' | 'open' | 'closed';

export interface PartnerOption {
  id: number;
  name: string;
}

export interface PartnersResponse {
  data: PartnerOption[];
}

export interface ReportFilters {
  reportType: ReportType;
  datePreset: DatePreset;
  startDate: string;
  endDate: string;
  status: CaseStatusFilter;
  partnerOrganizationId: number | null;
  serviceName: string | null;
}

export interface DateWindow {
  start: string;
  end: string;
}

export interface TableColumn {
  key: string;
  label: string;
  numeric?: boolean;
}

export type ReportTableRow = Record<string, string | number>;

export interface ReportResult {
  title: string;
  subtitle: string;
  columns: TableColumn[];
  rows: ReportTableRow[];
}

export function toIsoDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function formatReportCellValue(value: string | number): string {
  if (typeof value === 'number') {
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  }

  return value;
}
